import { Truck, Leaf, Zap, Wind } from "lucide-react";

// Type → color + icon (institutional palette Rías Baixas)
const TYPE_STYLES = {
  recogida:   { bg: "bg-salnes-atlantic",  fg: "text-white",         accent: "#0B4C7A", icon: Truck },
  barrido:    { bg: "bg-salnes-emerald",   fg: "text-white",         accent: "#10B981", icon: Wind },
  lavado:     { bg: "bg-[#2A9D8F]",        fg: "text-white",         accent: "#2A9D8F", icon: Wind },
  grua:       { bg: "bg-[#F4A261]",        fg: "text-white",         accent: "#F4A261", icon: Truck },
  furgoneta:  { bg: "bg-salnes-sand",      fg: "text-salnes-ink",    accent: "#F4E4C1", icon: Truck },
  inspeccion: { bg: "bg-[#6B7280]",        fg: "text-white",         accent: "#6B7280", icon: Truck },
  outro:      { bg: "bg-[#9CA3AF]",        fg: "text-white",         accent: "#9CA3AF", icon: Truck },
};

const FUEL_ICONS = {
  diesel_b7: Leaf,
  glp_autogas: Leaf,
  gnc_gnv: Leaf,
  gasolina_e10: Leaf,
  hvo_biocombustible: Leaf,
  electricidade_mix_es_2024: Zap,
};

// Institutional SVG silhouette per type — no external assets, no license risk.
export function VehicleSilhouette({ type = "outro", className = "" }) {
  const t = TYPE_STYLES[type] || TYPE_STYLES.outro;
  const paths = {
    recogida: (
      <>
        <path d="M14 42 L14 26 L26 26 L30 20 L54 20 L54 42 Z" fill={t.accent} opacity="0.9" />
        <rect x="32" y="24" width="18" height="14" fill="#FBFAF7" opacity="0.4" />
        <circle cx="22" cy="44" r="4" fill="#1F2937" />
        <circle cx="50" cy="44" r="4" fill="#1F2937" />
      </>
    ),
    barrido: (
      <>
        <path d="M12 42 L12 30 L48 30 L52 22 L58 22 L58 42 Z" fill={t.accent} opacity="0.9" />
        <circle cx="20" cy="44" r="3.5" fill="#1F2937" />
        <circle cx="46" cy="44" r="3.5" fill="#1F2937" />
        <circle cx="8" cy="46" r="6" fill={t.accent} opacity="0.5" />
      </>
    ),
    lavado: (
      <>
        <path d="M12 42 L12 24 L52 24 L52 42 Z" fill={t.accent} opacity="0.9" />
        <path d="M14 26 Q 20 20 26 26 Q 32 20 38 26 Q 44 20 50 26" fill="none" stroke="#FBFAF7" strokeWidth="1.5" />
        <circle cx="22" cy="44" r="4" fill="#1F2937" />
        <circle cx="46" cy="44" r="4" fill="#1F2937" />
      </>
    ),
    grua: (
      <>
        <path d="M14 42 L14 30 L44 30 L44 42 Z" fill={t.accent} opacity="0.9" />
        <path d="M32 30 L32 12 L52 12" fill="none" stroke={t.accent} strokeWidth="2.5" />
        <circle cx="22" cy="44" r="4" fill="#1F2937" />
        <circle cx="40" cy="44" r="4" fill="#1F2937" />
      </>
    ),
    furgoneta: (
      <>
        <path d="M14 42 L14 30 L36 30 L44 22 L52 22 L52 42 Z" fill={t.accent} opacity="0.95" stroke="#1F2937" strokeWidth="0.5" />
        <rect x="38" y="26" width="10" height="10" fill="#FBFAF7" opacity="0.6" />
        <circle cx="22" cy="44" r="3.5" fill="#1F2937" />
        <circle cx="46" cy="44" r="3.5" fill="#1F2937" />
      </>
    ),
    inspeccion: (
      <>
        <path d="M14 42 L14 32 L20 26 L44 26 L48 32 L48 42 Z" fill={t.accent} opacity="0.9" />
        <rect x="22" y="28" width="20" height="6" fill="#FBFAF7" opacity="0.5" />
        <circle cx="22" cy="44" r="3.5" fill="#1F2937" />
        <circle cx="42" cy="44" r="3.5" fill="#1F2937" />
      </>
    ),
    outro: (
      <>
        <rect x="14" y="26" width="38" height="16" fill={t.accent} opacity="0.9" />
        <circle cx="22" cy="44" r="4" fill="#1F2937" />
        <circle cx="44" cy="44" r="4" fill="#1F2937" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 66 50" className={className} role="img" aria-label={`Silhouette ${type}`}>
      {paths[type] || paths.outro}
    </svg>
  );
}

export function fuelIcon(fuel) {
  return FUEL_ICONS[fuel] || Leaf;
}

export function typeStyle(type) {
  return TYPE_STYLES[type] || TYPE_STYLES.outro;
}
